<template>
  <footer class="ac-footer">
    <p>版权所有 ©2019北京中科锐景科技有限公司 @2019 京ICP备17067392号-2</p>
  </footer>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  }
}
</script>
<style lang="less" scope>
.ac-footer{
  background-color: #111320;
  color:#adadae;
  overflow: hidden;
  padding: 15px 25px;
  text-align: center;
  font-size: 14px;
  height: 30px;
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/accountfooter.vue